import format from 'date-fns/format';
export default function formatDateTime(date) {
    const parsedDate = new Date(date instanceof Date ? date.getTime() : date);
    return format(parsedDate, 'dd/MM/yyyy HH:mm:ss');
}
